var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4",attrs:{"role":"alert"}},[_c('p',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }